// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__2L2_x","rowsWrapper":"style_rowsWrapper__RaPDs","rowWrapper":"style_rowWrapper__28jxz"};